/* eslint-disable */
import React from "react";
import {
  Flex,
  Link,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";

const VERSION = "2.1.7-PROD 20260318";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  const { toggleColorMode } = useColorMode();

  return (
    <Flex
      zIndex="3"
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px={{ base: "30px", md: "50px" }}
      pb="30px"
    >
      <Flex
        flexDirection="column"
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}
      >
        <Text>
          &copy; {1900 + new Date().getYear()}{" "}
          Toko Kopi Tuku. All Rights Reserved. Made with love by{" "}
          <Link
            mx="3px"
            color={textColor}
            href="https://www.miraisolusi.com"
            target="_blank"
            fontWeight="700"
          >
            Mirai
          </Link>
        </Text>
      </Flex>

      <Text
        color={textColor}
        fontSize="sm"
        textAlign={{
          base: "center",
          xl: "start",
        }}
      >
        Version {VERSION}
      </Text>
    </Flex>
  );
}
